/**
 * Debug utility for conditional logging
 * Only logs in development mode to improve production performance
 */

export const debugLog = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(...args);
  }
};

export const debugWarn = (...args: any[]) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn(...args);
  }
};

export const debugError = (...args: any[]) => {
  // Always log errors, but format them better
  console.error(...args);
};

export const debugGroup = (label: string) => {
  if (process.env.NODE_ENV === 'development') {
    console.group(label);
  }
};

export const debugGroupEnd = () => {
  if (process.env.NODE_ENV === 'development') {
    console.groupEnd();
  }
};

